import {
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
    NumberInput,
    ReferenceInput,
    SelectInput,
    required,
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { MediaInput } from '../../components/inputs/MediaInput';

export const CaseCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput
                source="title"
                validate={[required()]}
                fullWidth
            />
            <TextInput
                source="slug"
                fullWidth
                helperText="Будет сгенерирован автоматически, если не указан"
            />
            <MediaInput
                source="mapImageId"
                label="Изображение карты"
                validate={[required()]}
                helperText="Выберите изображение карты"
                accept="image/*"
                showPreview={true}
            />
            <MediaInput
                source="coverImageId"
                label="Обложка"
                validate={[required()]}
                helperText="Выберите изображение обложки"
                accept="image/*"
                showPreview={true}
            />
            <TextInput
                source="from"
                validate={[required()]}
                fullWidth
            />
            <TextInput
                source="to"
                validate={[required()]}
                fullWidth
            />
            <TextInput
                source="machine"
                validate={[required()]}
                fullWidth
            />
            <MediaInput
                source="sliderImageIds"
                label="Изображения слайдера"
                helperText="Выберите изображения для слайдера"
                accept="image/*"
                multiple={true}
                showPreview={true}
            />
            <NumberInput
                source="time"
                validate={[required()]}
                fullWidth
                min={1}
                helperText="Время доставки в днях"
            />
            <TextInput
                source="logisticPrice"
                validate={[required()]}
                fullWidth
            />
            <TextInput
                source="exploitationPrice"
                validate={[required()]}
                fullWidth
            />
            <MediaInput
                source="bigMapImageId"
                label="Большое изображение карты"
                helperText="Выберите большое изображение карты (необязательно)"
                accept="image/*"
                showPreview={true}
            />
            <TextInput
                source="descriptionTitle"
                validate={[required()]}
                fullWidth
            />
            <RichTextInput
                source="description"
                validate={[required()]}
                fullWidth
            />
            <ReferenceInput source="categoryId" reference="case-categories">
                <SelectInput optionText="name" validate={[required()]}/>
            </ReferenceInput>
            <BooleanInput
                source="isActive"
                defaultValue={true}
            />
            <NumberInput
                source="sortOrder"
                defaultValue={0}
                min={0}
            />
        </SimpleForm>
    </Create>
);
